import store from '@/store';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';

const GHS_MATERIALS = [
  {
    name: 'PML-GHS100 (13X13)R',
    articleNumber: '1014289',
  },
  {
    name: 'PML-GHS100 (25X25)R',
    articleNumber: '1014290',
  },
  {
    name: 'US-PML-GHS100 (13X13)',
    articleNumber: '1014287',
  },
  {
    name: 'US-PML-GHS100 (25X25)',
    articleNumber: '1014288',
  },
];

export default () => {
  const { core: { colorSchema } } = store.getState();
  const matfileTemplate = getBuildedMatfileTemplate();

  return GHS_MATERIALS.some(item => matfileTemplate?.name.includes(item.name) || `${colorSchema?.article_number || ''}` === item.articleNumber);
};
